export enum MDSSidebarSectionSlotName {
  Header = "header",
}

export enum MDSSidebarSectionItemSlotName {
  ButtonsRight = "buttonsRight",
}

export enum MDSSidebarSectionHeaderSlotName {
  ButtonsRight = "buttonsRight",
}
